const reducer = (state = [], action) => {
    if (action.type === "CHECK_ROW") {
        return [...state, action.payload];
    } else if (action.type === "UNCHECK_ROW") {
        return state.filter(rId => rId !== action.payload);
    } else if (action.type === "CHECK_ALL_ROWS") {
        return action.payload;
    } else {
        return state;
    }    
}
export default reducer;